export interface ChainConfig {
  chainId:       number;
  name:          string;
  currency:      string;
  rpcUrls:       string[];
  blockExplorer: string;
}

export const CHAINS: Record<string, ChainConfig> = {
  polygon: {
    chainId:       137,
    name:          "Polygon Mainnet",
    currency:      "POL",
    rpcUrls:       [
      "https://polygon-bor-rpc.publicnode.com",   // most reliable — first
      "https://polygon.llamarpc.com",
      "https://rpc.ankr.com/polygon",
      "https://polygon-rpc.com",
    ],
    blockExplorer: "https://polygonscan.com",
  },
  amoy: {
    chainId:       80002,
    name:          "Polygon Amoy Testnet",
    currency:      "POL",
    rpcUrls:       ["https://rpc-amoy.polygon.technology"],
    blockExplorer: "https://amoy.polygonscan.com",
  },
};
